var render, staticRenderFns
import script from "./RichTextDisplay.vue?vue&type=script&lang=js"
export * from "./RichTextDisplay.vue?vue&type=script&lang=js"
import style0 from "./RichTextDisplay.vue?vue&type=style&index=0&id=6f8d7bf4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d7bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f8d7bf4')) {
      api.createRecord('6f8d7bf4', component.options)
    } else {
      api.reload('6f8d7bf4', component.options)
    }
    
  }
}
component.options.__file = "resources/js/frontend/components/common/editors/RichTextDisplay.vue"
export default component.exports